var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 14.25C4.5 15.075 5.175 15.75 6 15.75H12C12.825 15.75 13.5 15.075 13.5 14.25V5.25H4.5V14.25ZM6.345 8.91L7.4025 7.8525L9 9.4425L10.59 7.8525L11.6475 8.91L10.0575 10.5L11.6475 12.09L10.59 13.1475L9 11.5575L7.41 13.1475L6.3525 12.09L7.9425 10.5L6.345 8.91ZM11.625 3L10.875 2.25H7.125L6.375 3H3.75V4.5H14.25V3H11.625Z","fill":"currentColor"}));
}

Trash.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Trash;

Trash.default = Trash;
